var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAlert = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20",
    height: 20,
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 9.991679,2.1358348 c 0.68578,0 1.241679,0.555925 1.241679,1.241679 v 6.6222767 c 0,0.6857795 -0.555899,1.2416795 -1.241679,1.2416795 C 9.305924,11.24147 8.75,10.68557 8.75,9.9997905 V 3.3775138 c 0,-0.685754 0.555924,-1.241679 1.241679,-1.241679 z m 0,13.2449722 c -0.685755,0 -1.241679,0.556022 -1.241679,1.241674 0,0.685662 0.555924,1.241684 1.241679,1.241684 h 0.01664 c 0.685756,0 1.241681,-0.556022 1.241681,-1.241684 0,-0.685652 -0.555925,-1.241674 -1.241681,-1.241674 z",
    fill: "#000000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/alert.a1a5925a.svg";
export { ForwardRef as ReactComponent };